// extracted by mini-css-extract-plugin
export default {"wrapper_forms":"addEmployee_wrapper_forms__PnOSL"};